import React from 'react';
import Box from '@mui/material/Box';
import cx from 'classnames';
import Typography from '@mui/material/Typography';
import { lighten, alpha } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    'position': 'relative',
    'backgroundColor': alpha(theme.palette.primary.contrastText, 0.6),
    'color': theme.palette.primary.main,
    'borderRadius': 12,
    'padding': theme.spacing(2.2),
    'cursor': 'pointer',
    'boxShadow': `${lighten(theme.palette.primary.main, 0.6)} 0px 1px 12px 0px`,
    'textAlign': 'center',
    'transition': 'all 0.3s ease-in-out',
    '&:hover': {
      backgroundColor: theme.palette.primary.contrastText,
    },
  },
  primary: {
    'paddingTop': theme.spacing(3),
    'backgroundColor': theme.palette.primary.main,
    'color': theme.palette.primary.contrastText,
    'marginBottom': theme.spacing(2),
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, 0.9),
    },
  },
  badge: {
    backgroundColor: theme.palette.primary.main,
    fontSize: 28,
    lineHeight: 1.3,
    width: 50,
    height: 50,
    padding: 6,
    borderRadius: '50%',
    position: 'absolute',
    top: -25,
    left: 'calc(50% - 25px)',
    boxShadow: `rgba(0,0,0,.1) 0px -6px 12px 0px`,
  },
}));

const WidgetListItem = ({ id, title, subtitle, isPrimary, onClick }) => {
  const classes = useStyles();
  return (
    <Box
      className={cx(classes.root, { [classes.primary]: isPrimary })}
      onClick={() => onClick(id)}
    >
      <Typography
        lineHeight={1.1}
        variant="h3"
        fontSize={22}
        fontWeight={600}
        color="inherit"
      >
        {title}
      </Typography>
      {isPrimary && (
        <Typography color="inherit" varinat="caption">
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default WidgetListItem;
